const SERVER_URL = "http://localhost:10000"
  // process.env.REACT_APP_FIRESTORE_COPY_SERVER_URL ||
  // process.env.REACT_APP_SERVER_URL ||
  // (process.env.NODE_ENV === "development"
  //   ? "http://localhost:10000"
  //   : "https://rosemountstaffserver.onrender.com")
  .replace(/\/$/, "");

export const copyFirestoreCollection = async (request) => {
  const response = await fetch(`${SERVER_URL}/api/admin/firestore-copy`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(request),
  });
  const payload = await response.json().catch(() => ({}));

  if (!response.ok || !payload.ok) {
    throw new Error(payload.error || "The collection could not be copied.");
  }

  return payload.result;
};
